var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowRight);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_right.1b4702dbb11f71190b6bbb871bf38c48.svg";
export { ForwardRef as ReactComponent };